<template>
  <div class="pre-holder-page" v-if="emptyLoaderShow">
    <div class="pre-holder-panel">
      <div :class="'holder-item '+(index==3?'big':'')" v-for="index in 15" :key="index">

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      emptyLoaderShow: {
        type: Boolean,
        default: false,
      }
    },
    name: "predataholder"
  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .pre-holder-page {
    position: fixed;
    left: 0;
    .top(98);
    right: 0;
    .bottom(98);
    z-index: 10;
    overflow-y: auto;

    .pre-holder-panel {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .pl(10);
      .pr(10);


      .holder-item {
        width: 49%;
        .h(420);
        .b-radius(24);
        .mb(18);
        display: inline-block;
        background: url("../../assets/imgs/web_load.gif") no-repeat;
        background-size: cover;
      }

      .holder-item.big {
        .w(730);
        .h(283);
        display: block;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/widget/predataholder.vue